// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AaWe","type":"styles_type__26kwJ","choices":"styles_choices__1Dmnm"};